<template>
  <v-col cols="12" sm="12">
    <v-form ref="form">
      <DateTimeInput
        :date="time_from"
        @update="val => (time_from = val)"
        :date-label="$t('meter-units.from-date')"
        :time-label="$t('meter-units.from-time')"
        :rules="[rules.required, backEndValidation('start_time')]"
      ></DateTimeInput>
      <DateTimeInput
        :date="time_to"
        @update="val => (time_to = val)"
        :date-label="$t('meter-units.to-date')"
        :time-label="$t('meter-units.to-time')"
        :rules="[rules.required, backEndValidation('end_time')]"
        default-time="23:59"
      ></DateTimeInput>
      <v-autocomplete
        chips
        multiple
        v-model="realSelectedMeterUnits"
        :items="meterUnits"
        :item-text="fullPath"
        item-value="id"
        :label="$t('meter-units.meter-units')"
        :rules="[rules.required]"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 3">
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === 3" class="ma-1 grey--text caption"
            >(+{{ realSelectedMeterUnits.length - 3 }} {{ $t("others") }})</span
          >
        </template>
      </v-autocomplete>
      <v-btn
        color="primary mr-3"
        v-on:click="reprocess()"
        v-if="!hideButton"
        :loading="loading"
      >
        <v-icon left>mdi-download</v-icon>
        {{ $t(`buttons.reprocess-transmissions`) }}
      </v-btn>
    </v-form>
  </v-col>
</template>

<script>
import moment from "moment";
import DateTimeInput from "../../../common/inputs/DateTimeInput";
import { rules } from "../../../mixins/rules";
export default {
  name: "RealignRecords",
  mixins: [rules],
  components: { DateTimeInput },
  props: {
    meterUnits: {
      type: Array
    },
    project_id: {
      type: String
    },
    selectedMeterUnits: {
      type: [Boolean, Array],
      default: function() {
        return false;
      }
    },
    hideButton: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    loadingProp: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      project: {},
      realSelectedMeterUnits: [],
      time_from: "",
      time_to: ""
    };
  },
  methods: {
    updateSelected() {
      if (this.selectedMeterUnits) {
        this.realSelectedMeterUnits = this.selectedMeterUnits.map(i => i.id);
      } else {
        this.realSelectedMeterUnits = this.meterUnits.map(i => i.id);
      }
    },
    reprocess() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        let project = this.project;
        let toUTC = function(date) {
          return (
            date &&
            moment
              .tz(moment(date).format("YYYY-MM-DDTHH:mm:ss"), project.timezone)
              .utc()
              .format()
          );
        };
        this.$store
          .dispatch("projectMeteringStore/realignRecordsStore/reprocess", {
            item: {
              meter_units: this.realSelectedMeterUnits,
              start_time: toUTC(this.time_from),
              end_time: toUTC(this.time_to),
              project_id: this.project_id
            },
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    fullPath(i) {
      return [
        ...i.path.reduce((ac, i) => {
          ac.push(i.name);
          return ac;
        }, []),
        i.name
      ].join(" > ");
    }
  },
  computed: {
    loading: {
      set(val) {
        this.$emit("update:loadingProp", val);
      },
      get() {
        return this.loadingProp;
      }
    }
  },
  watch: {
    meterUnits: {
      handler: function() {
        this.updateSelected();
      },
      deep: true
    },
    selectedMeterUnits: {
      handler: function() {
        this.updateSelected();
      },
      deep: true
    }
  },
  mounted() {
    this.updateSelected();
    this.$store.dispatch("projectStore/get", {
      id: this.project_id,
      onSuccess: project => {
        this.project = project;
      }
    });
  }
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
</style>
